export const dashboard_lang = {
  TH: {
    month_search: "ค้นหาข้อมูล",
    choose_month: "เลือกปี/เดือน/วันที่ต้องการ",
    choose_monthh: "เลือกปี/เดือนที่ต้องการ",
    choose_year: "เลือกปีที่ต้องการ",
    date_start: 'เลือกวันเริ่มต้น/สิ้นสุด',
    choose_type_report: "เลือกแสดงข้อมูล"
  },
  EN: {
    month_search: "search by month/day",
    choose_month: "choose month and year",
    choose_type_report: "choose type report",
    choose_monthh: "choose month and year",
    choose_year: "choose year",
    date_start:'Select start/end date',


  }
}
